"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupCookie = void 0;
const utils_1 = require("../../utils/utils");
const modal_1 = require("../../components/modal/modal");
class PopupCookie extends modal_1.ModalComponent {
    mountComponent() {
        if (this.isEditor) {
            this.editor.on('BLOCK_SELECT', this._handleBlockSelect);
            this.editor.on('BLOCK_DESELECT', this._handleBlockDeselect);
            return;
        }
        window.Shopify.loadFeatures?.([
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ], error => {
            if (error) {
                throw error;
            }
            const userCanBeTracked = window.Shopify.customerPrivacy?.userCanBeTracked();
            const userTrackingConsent = window.Shopify.customerPrivacy?.getTrackingConsent();
            if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
                this.show();
            }
        });
    }
    _handleBlockSelect = ({ detail: { blockId } }) => {
        if (this.dataset.blockId === blockId) {
            this.show();
        }
    };
    _handleBlockDeselect = ({ detail: { blockId } }) => {
        if (this.dataset.blockId === blockId) {
            this.hide();
        }
    };
    show = async () => {
        await super.show();
        this.addListener(this.selectBtn('accept'), 'click', this.onAccept);
        this.addListener(this.selectBtn('decline'), 'click', this.onDecline);
        this.addListener(this.selectBtn('close'), 'click', this.onDecline);
    };
    hide = async () => {
        this.removeListener(this.selectBtn('accept'), 'click', this.onAccept);
        this.removeListener(this.selectBtn('decline'), 'click', this.onDecline);
        this.removeListener(this.selectBtn('close'), 'click', this.onDecline);
        await super.hide();
    };
    onAccept = () => {
        if (this.isEditor) {
            this.hide();
            return;
        }
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide);
    };
    onDecline = () => {
        if (this.isEditor) {
            this.hide();
            return;
        }
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.hide);
    };
    selectBtn(type) {
        if (!this.isOpen) {
            return null;
        }
        return (0, utils_1.$el)(`[data-${type}-btn]`, this);
    }
}
exports.PopupCookie = PopupCookie;
